module.exports = __webpack_public_path__ + "static/media/yelp-social-media-svgrepo-com.abecf1c8.svg";